import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { folderService } from '../services/folderService';
import type { CreateFolderDto } from '../types';

export function useCreateFolder() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('folders');

  return useMutation({
    mutationFn: (data: CreateFolderDto) => folderService.createFolder(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['folders'] });
      toast.success({ title: t('toasts.createSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.createError') });
    },
  });
}
